import React, {lazy} from 'react';
import {Route, IndexRoute} from 'react-router';

const AssignmentBuilderLayoutWithRequiredSession = lazy(() =>
  import('./AssignmentBuilderLayout.react').then((module) => ({
    default: module.AssignmentBuilderLayoutWithRequiredSession
  }))
);

const AssignmentSettings = lazy(() =>
  import('./AssignmentSettings/AssignmentSettings.react').then((module) => ({
    default: module.AssignmentSettings
  }))
);

const AssignmentSharingV3 = lazy(() =>
  import('./Document/AssignmentSharing/AssignmentSharingV3.react').then((module) => ({
    default: module.AssignmentSharing
  }))
);

const DocumentContentDiscovery = lazy(
  () => import('./Document/DocumentContentDiscovery/DocumentContentDiscovery.react')
);

const ReviewQuestions = lazy(() => import('./ViewAssignment/ViewAssignment.react'));

const ContentDiscoveryRoutes = (
  <Route
    path='/assignment-builder/create-assignment'
    component={AssignmentBuilderLayoutWithRequiredSession}
  >
    <IndexRoute component={DocumentContentDiscovery} />
    {/* Create routes */}
    <Route path='settings' component={AssignmentSettings} />
    <Route path='classroom/:classroomId/settings' component={AssignmentSettings} />
    <Route
      path='classroom/:classroomId/student/:studentId/settings'
      component={AssignmentSettings}
    />
    <Route path='confirm' component={AssignmentSharingV3} />
    {/* Edit routes */}
    <Route path='folder/:folderId' component={DocumentContentDiscovery} />
    <Route path=':assignmentId' component={ReviewQuestions} />
    <Route path=':assignmentId/draft' component={DocumentContentDiscovery} />
    <Route path=':assignmentId/settings'>
      <IndexRoute component={AssignmentSettings} />
      <Route path='draft' component={AssignmentSettings} />
    </Route>
    <Route path=':assignmentId/classroom/:classroomId/settings'>
      <IndexRoute component={AssignmentSettings} />
      <Route path='draft' component={AssignmentSettings} />
    </Route>
    <Route path=':assignmentId/classroom/:classroomId/student/:studentId/settings'>
      <IndexRoute component={AssignmentSettings} />
      <Route path='draft' component={AssignmentSettings} />
    </Route>
    <Route path=':assignmentId/confirm'>
      <IndexRoute component={AssignmentSharingV3} />
      <Route path='draft' component={AssignmentSharingV3} />
    </Route>
  </Route>
);

export default ContentDiscoveryRoutes;
